export const reportPagesKey = () => ({
  /**
   * فروش و مشتریان - فاکتورهای فروش
   * همچنین از صفحه حساب های تفصیلی و لیست مشتریان به این صفحه ریدایرکت انجام میشود
   * /Invoice
   */
  menuInvoice: 'menu.invoice',

  /**
   * مدیریت کسب و کار - منوی شعبه -  لیست شعبه ها - گزارش صورت حساب
   * /Branch/Transactions/:id
   * * خدمات تنخواه گردانی - لیست  تنخواه گردان - گزارش صورت حساب
   * /Branch/Transactions/:id?imprest=true
   */
  branchTransactionWithId: 'branch.transactions.withId',

  /**
   * مدیریت کسب و کار - شعبه ها و زیرمجموعه - گزارش صورتحساب  شعبه ها
   * /Branch/Transactions
   */
  menuBranchTransaction: 'menu.branch.transactions',

  /**
*عملیات مالی و بانکی  - حساب‌های تفصیلی  - گزارش درخواست‌های تسویه
* /SettlementGuild
*/
  settlementGuildTransaction: 'settlementGuild.transactions',


  /**
  *عملیات مالی و بانکی  - حساب‌های دیجیتال  - گزارش درخواست‌های تسویه
  * /SettlementGuild
  */
  settlementWalletTransaction: 'settlementWallet.transactions',

  /**
 *عملیات مالی و بانکی  -  تفویض وجه  - وجه‌های تفویض شده به من
 * /SettlementGuild
 */
  menuDelegation: 'menu.Delegation',



  menuTransactionWallet: 'menu.transactionWallet',
  menuTransactionGuild: 'menu.transactionGuild',
  menuTransactionImprest: 'menu.transactionImprest',

  /**
   * عملیات مالی و بانکی - تفویض وجه - وجه های تفویض شده به سایرین
   * /DefineDelegation/List
   * {url: "/DefineDelegation/List", key: "menu.delegation.define.list"}
   */
  menuDelegationToOther: 'menu.delegation.define.list',

  menuCustomerList: 'menu.CustomerList',

  voucherList: 'menu.VoucherList',

  imprestList: 'menu.imprest.list',

    /**
 فروش و مشتریان - فاکتورهای خرید
 * /InvoiceCreditor
 */
  menuInvoiceCreditor: 'menu.InvoiceCreditor',


});
